<template>
  <popup-base :type-is-warning="true" @close="close">
    <template #header-text>
      {{ $t('PopupBaseNoProducts.not_all_products_available') }}
    </template>
    <template #header-notice>
      {{ $t('PopupBaseNoProducts.brand_color_combination_not_available') }}
    </template>
    <template #body>
      <p>
        {{ $t('PopupBaseNoProducts.the_following_pieces_are_not_available') }}
      </p>
      <div class="list">
        <LdsRippleWaiter v-if="missingProductIds.length === 0" />
        <ul
          v-for="product in missingCategoryProducts"
          :key="product.id"
          class="item missing-products"
        >
          <li>{{ product.name }}</li>
        </ul>
      </div>
    </template>
    <template #footer>
      <button class="emat-btn" @click="close">
        {{ $t('PopupBaseNoProducts.back_to_current_selection') }}
      </button>
      <button class="emat-btn" @click="selectProducts">
        {{
          $t('PopupBaseNoProducts.go_to_next', {
            link: brandOrColor ? brandOrColor.name : null,
          })
        }}
      </button>
    </template>
  </popup-base>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import PopupBase from './PopupBase';
import LdsRippleWaiter from '../utilities/LdsRippleWaiter';

export default {
  name: 'PopupNoProductsAvailable',
  components: { LdsRippleWaiter, PopupBase },
  props: {
    popupType: {
      type: String,
      validator: (value) => ['brand', 'color'].includes(value),
    },
  },
  computed: {
    ...mapState('popup', ['metaData']),
    ...mapState('category-products', ['products']),
    ...mapState('brand-color-selection', [
      'brands',
      'colors',
      'missingProductIds',
    ]),
    missingCategoryProducts() {
      return this.products.filter((product) =>
        this.missingProductIds.includes(product.id)
      );
    },
    brandOrColor() {
      if (this.metaData.brandId) {
        return this.brands.find((brand) => brand.id === this.metaData.brandId);
      }

      if (this.metaData.colorId) {
        return this.colors.find((color) => color.id === this.metaData.colorId);
      }

      return null;
    },
  },
  methods: {
    ...mapActions('build', ['updateProduct']),
    ...mapActions('brand-color-selection', ['getBrandColorTypes']),
    ...mapMutations('brand-color-selection', ['setMissingProductIds']),
    ...mapMutations('popup', ['closePopup']),
    ...mapMutations('filters', ['setSelectedBrandId', 'setSelectedColorId']),
    async selectProducts() {
      await this.removeProductsWhichAreNotAvailable();
      await this.getBrandColorTypes();
      this.selectBrandOrColor();
      this.close();
    },
    async removeProductsWhichAreNotAvailable() {
      for (const product of this.missingCategoryProducts) {
        await this.updateProduct({
          id: product.id,
          amount: 0,
        });
      }
    },
    selectBrandOrColor() {
      if (this.metaData.brandId) {
        this.setSelectedBrandId(this.metaData.brandId);
      } else if (this.metaData.colorId) {
        this.setSelectedColorId(this.metaData.colorId);
      }
    },
    close() {
      this.setMissingProductIds([]);
      this.closePopup();
    },
  },
};
</script>
